import Vue from 'vue'
import ScrollLock from '../../components/rest-menu-components/utilities/scroll-lock'
var axios = require('axios')
var Sentry = require('@sentry/vue')

const state = {
  tabs: [],
  currentTab: {},
  initDefaultTab: {},
  currentItem: {},
  isCurrentItemLoaded: false,
  isCurrentEditItemLoaded: false,
  currentEditItem: {},
  editItemOpen: false,
  toastedMessage: '',
  restInfo: {},
  customerCart: {},
  deliveryTime: {},
  showCart: false,
  cartIsLoading: false,
}

export const actions = {
  setInitState({ commit }) {
    if (window.restMenu) {
      var tabs = window.restMenu.menuData
      var restInfo = window.restMenu.restInfo
      var deliveryTime = window.restMenu.deliveryTime
      var tabShow = restMenu.menuData.filter((tab) => {
        return tab.default == 1
      })
      if (tabShow.length == 0) {
        tabShow = window.restMenu.menuData[0]
        commit('setTab', tabShow)
      } else {
        commit('setTab', tabShow[0])
      }
      commit('setMenu', tabs)
      commit('setRestInfo', restInfo)
      commit('setDeliveryTime', deliveryTime)
    } else {
      Sentry.captureException(new Error('restMenu: Initial menu state failed to load.'))
      return
    }
  },
  setInitCustomerCartState({ commit }) {
    if (window.cartData) {
      var customerCartData = window.cartData
      commit('setCustomerCartData', customerCartData)
    } else {
      Sentry.captureException(new Error('Rest Menu: Initial customer cart state failed to load.'))
      return
    }
  },
  getCustomerCartData({ commit }) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'getCustomerCart')
    params.append('restId', window.restId)
    axios.defaults.headers['Pragma'] = 'no-cache' // prevents IE11 from caching the get request
    return axios
      .get('/restMenu.pl?' + params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          commit('setCartIsLoading', false)
          return true
        } else {
          commit('setCartIsLoading', false)
          Sentry.captureException(new Error('Rest Menu Cart: Request to get customer cart data failed.'))
          return false
        }
      })
      .catch(function (error) {
        commit('setCartIsLoading', false)
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request for getCustomerCartData Failed'))
        return false
      })
  },
  checkTime({ commit, dispatch }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'checktime')
    params.append('duedate', payload.duedate)
    params.append('hour', payload.dueHour)
    params.append('minute', payload.dueMin)
    params.append('restId', payload.restId)
    return axios
      .post('/later-order.pl?', params)
      .then((response) => {
        if (response.data.errors) {
          var errorMsg = ''
          for (var eachError in response.data.errors) {
            errorMsg += '\n' + response.data.errors[eachError] + '\n'
          }
          commit('setToastedMessage', errorMsg)
          dispatch('showToastedErrorMessage')
          Sentry.addBreadcrumb({
            category: 'exception',
            message: errorMsg,
            level: Sentry.Severity.error,
          })
          Sentry.captureException(new Error('user entered an invalid "later date/time"'))
          return false
        }
        if (response.data.success) {
          var date = new Date(
            payload.duedate.slice(0, 4),
            payload.duedate.slice(4, 6) - 1,
            payload.duedate.slice(6, 8),
            payload.dueHour,
            payload.dueMin
          )
          var dateTimeString = date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
          })
          let [dateSplit, timeSplit, period] = dateTimeString.split(' ')
          dateTimeString = `${dateSplit.replace(',', '')} at ${timeSplit}${period}`.toLowerCase()
          var delTime = { type: 'later', time: dateTimeString }
          commit('setDeliveryTime', delTime)
          return true
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Network Error: request for "checktime" Failed'))
        return false
      })
  },
  setTime({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'set')
    params.append('duedate', payload.duedate)
    params.append('hour', payload.dueHour)
    params.append('minute', payload.dueMin)
    return axios
      .post('/later-order.pl?', params)
      .then(function () {
        return true
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Network Error: request for "setTime" Failed'))
        return false
      })
  },
  updateDeliveryASAP({ commit, dispatch, state }) {
    dispatch('showToastedLoading')
    if (!state.restInfo.restInfoBanner.isOpen) {
      Vue.toasted.clear()
      commit('setToastedMessage', 'This restaurant is currently unavailable for ASAP orders.')
      dispatch('showToastedErrorMessage')
      return false
    }
    axios
      .post('/order-time.pl?')
      .then((response) => {
        Vue.toasted.clear()
        if (response.data.type === 'asap') {
          const delTime = { type: response.data.type, time: response.data.estimate }
          commit('setDeliveryTime', delTime)
          return true
        }
      })
      .catch((error) => {
        Vue.toasted.clear()
        console.log('error response!', error)
        if (error.response && error.response.data && error.response.data.message) {
          commit('setToastedMessage', error.response.data.message)
          dispatch('showToastedErrorMessage')
        } else if (!state.restInfo.restInfoBanner.isOpen) {
          commit(
            'setToastedMessage',
            'This restaurant is currently closed or not available for ASAP delivery, please select a later delivery time.'
          )
          dispatch('showToastedErrorMessage')
        } else {
          commit(
            'setToastedMessage',
            'One or more menu items or restaurants in your order are not available for ASAP delivery. Please select a later delivery time.'
          )
          dispatch('showToastedErrorMessage')
        }
        Sentry.addBreadcrumb({
          category: 'exception',
          message: "Rest menu: request for 'updateDeliveryASAP' failed.",
          level: Sentry.Severity.error,
          data: error,
        })
        Sentry.captureException(new Error('Rest Menu Network Error: request for "updateDeliveryASAP" Failed'))
      })
  },
  getItemOptions({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'getOptions')
    params.append('itemId', payload.itemId)
    return axios
      .post('/yourOrder.pl?', params)
      .then((response) => {
        if (response.data) {
          return response.data
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request for getOptions Failed'))
        return false
      })
  },
  getOptionDetails({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'optDetails')
    params.append('itemId', payload.itemId)
    return axios
      .post('/yourOrder.pl?', params)
      .then((response) => {
        if (response.data.success) {
          return response.data.success
        } else {
          Sentry.captureException(new Error('Rest Menu Cart: Request for optDetails failed.'))
          return false
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request for optDetails Failed'))
        return false
      })
  },
  async editItem({ commit, dispatch }, payload) {
    dispatch('openCloseEditItemModal', true)
    await dispatch('getCurrentItemEdit', {
      itemId: payload.itemId,
      restId: payload.restId,
    })
  },
  removeItem({ commit }, payload) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'removeItem')
    params.append('itemId', payload.itemId)
    params.append('restId', payload.restId)

    return axios
      .post('/restMenu.pl?', params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          commit('setCartIsLoading', false)
          return true
        } else {
          Sentry.addBreadcrumb({
            category: 'exception',
            message: 'failed to remove itemId: ' + payload.itemId,
            level: Sentry.Severity.error,
          })
          Sentry.captureException(new Error('failed to remove item from cart'))
          commit('setCartIsLoading', false)
          return false
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request removeItem failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  editItemQty({ commit, dispatch }, payload) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'editItemQty')
    params.append('qty', payload.qty)
    params.append('itemId', payload.itemId)
    params.append('optns', payload.options)
    params.append('restId', payload.restId)
    if (payload.whofor) {
      params.append('whofor', payload.whofor)
    }
    if (payload.comment) {
      params.append('comments', payload.comment)
    }

    return axios
      .post('/restMenu.pl?', params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          commit('setCartIsLoading', false)
          return true
        } else {
          Sentry.addBreadcrumb({
            category: 'exception',
            message: 'failed to edit item qty: ' + payload.qty + ' for itemId: ' + payload.itemId,
            level: Sentry.Severity.error,
          })
          Sentry.captureException(new Error('failed to edit qty for item in cart'))
          commit('setCartIsLoading', false)
          return false
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request editItemQty failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  applyCoupon({ commit }, payload) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'apply')
    params.append('couponcode', payload.couponCode)
    return axios
      .post('/applyCoupon.pl', params)
      .then((response) => {
        if (response.data.errors) {
          var errorMsg = "We're sorry, we are unable to apply your coupon for the following reason:\n"

          for (var eachError in response.data.errors) {
            errorMsg += '\n - ' + response.data.errors[eachError] + '\n'
          }
          Sentry.addBreadcrumb({
            category: 'exception',
            message: errorMsg,
            level: Sentry.Severity.error,
          })
          Sentry.captureException(new Error('Rest Menu Cart: apply coupon error'))
          commit('setCartIsLoading', false)
          alert(errorMsg)
          return false
        } else {
          commit('setTotal', response.data.success.total)
          commit('setCoupon', { response: response.data.success, couponName: payload.couponCode })
          if (response.data.success.overrideMin) {
            commit('setOverrideMin', true)
            commit('setMinimumStatus', 3)
            commit('setDifference', '')
            commit('setCustIsPayingMinFee', false)
          }
          commit('setCartIsLoading', false)
          return true
        }
      })
      .catch((error) => {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request to applyCoupon Failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  removeCoupon({ commit }, payload) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'remove')
    return axios
      .post('/applyCoupon.pl', params)
      .then((response) => {
        if (response.data.success) {
          commit('setTotal', response.data.success.total)
          commit('setCoupon', { response: response.data.success })
          commit('setCartIsLoading', false)
          return true
        }
      })
      .catch((error) => {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request to removeCoupon Failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  setTip({ commit }, payload) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', payload.mode) // mode is either 'custom' or 'perc'
    if (payload.mode === 'custom') {
      params.append('tipCustom', payload.tipAmt)
    } else {
      params.append('tipPerc', payload.tipPerc)
    }
    return axios
      .post('/setTip.pl', params)
      .then((response) => {
        if (response.data.tipAmt) {
          commit('setTotal', response.data.total)
          commit('setTip', response.data.tipAmt)
          commit('setTipPercent', response.data.success.tipPerc)
          commit('setCartIsLoading', false)
          return response.data
        } else if (response.data.errors) {
          if (response.data.minGrat) {
            commit('setTotal', response.data.total)
            commit('setTip', response.data.success.tip)
            commit('setTipPercent', response.data.success.tipPerc)
            commit('setCartIsLoading', false)
          }
          var errorMsg = ''
          for (var eachError in response.data.errors) {
            errorMsg += '\n' + response.data.errors[eachError] + '\n'
          }
          commit('setCartIsLoading', false)
          alert(errorMsg)
          return response.data
        }
      })
      .catch((error) => {
        commit('setCartIsLoading', false)
        Sentry.captureException(new Error('Rest Menu Network Error: request to setTip Failed'))
        return false
      })
  },
  restComment({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'restComment')
    params.append('restId', payload.restId)
    params.append('comment', payload.comment)
    return axios
      .post('/yourOrder.pl', params)
      .then((response) => {
        if (response.data.errors) {
          var errorMsg = "We're sorry, we are unable to change your comment for the following reason:\n"
          for (var eachError in response.data.errors) {
            errorMsg += '\n - ' + response.data.errors[eachError] + '\n'
          }
          Sentry.addBreadcrumb({
            category: 'exception',
            message: errorMsg,
            level: Sentry.Severity.error,
          })
          Sentry.captureException(new Error('Rest Menu Cart: rest comment error'))
          alert(errorMsg)
          return false
        } else {
          commit('setRestComment', payload)
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request restComment Failed'))
        return false
      })
  },
  sendBackToQueue({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'approve')
    params.append('cartid', payload.cartId)
    return axios.post('/yourOrder.pl', params).then((response) => {
      window.location.href = '/orderqueue.pl'
      return true
    })
  },
  payMinFee({ commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'payMinFee')
    params.append('restId', window.restId)
    if (payload.remove === 'dontpay') {
      params.append('remove', payload.remove)
    }
    if (payload.cartId) {
      params.append('cartid', payload.cartId)
    }
    return axios
      .post('/restMenu.pl', params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          return true
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request payMinFee Failed'))
        return false
      })
  },
  clearOrder({ commit }, restID) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'clearOrder')
    params.append('restId', restID)

    return axios
      .post('/restMenu.pl', params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          commit('setCartIsLoading', false)
          return true
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request clearOrder Failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  clearAllOtherRestOrders({ dispatch, commit }, restID) {
    commit('setCartIsLoading', true)
    var params = new URLSearchParams()
    params.append('mode', 'clearAllOtherRestOrders')
    params.append('restId', restID)

    return axios
      .post('/restMenu.pl', params)
      .then((response) => {
        if (response.data.success) {
          commit('setCustomerCartData', response.data.success)
          commit('setCartIsLoading', false)
          return true
        }
      })
      .catch(function (error) {
        Sentry.captureException(new Error('Rest Menu Cart Network Error: request clearAllOtherRestOrders Failed'))
        commit('setCartIsLoading', false)
        return false
      })
  },
  getCurrentItem({ dispatch, commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'getCurrentItem')
    params.append('restId', payload.restId)
    params.append('itemId', payload.itemId)
    axios
      .get('/restMenu.pl?' + params)
      .then((response) => {
        if (response.data) {
          commit('setCurrentItem', response.data)
        } else {
          commit('setToastedMessage', 'Could not get item options.')
          dispatch('showToastedErrorMessage')
        }
      })
      .catch(function (error) {
        console.log(error)
        commit('setToastedMessage', 'Network request failed.')
        dispatch('showToastedErrorMessage')
        Sentry.captureException(new Error('Rest Menu Error: getCurrentItem request failed'))
      })
      .then(() => {
        commit('setIsCurrentItemLoaded', true)
      })
  },
  getCurrentItemEdit({ dispatch, commit }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'getCurrentItemEdit')
    params.append('restId', payload.restId)
    params.append('itemId', payload.itemId)
    return axios
      .get('/restMenu.pl?' + params)
      .then((response) => {
        if (response.data) {
          commit('setCurrentEditItem', response.data)
        } else {
          commit('setToastedMessage', 'Could not get edit item options.')
          dispatch('showToastedErrorMessage')
        }
      })
      .catch(function (error) {
        console.log(error)
        commit('setToastedMessage', 'Network request failed.')
        dispatch('showToastedErrorMessage')
        Sentry.captureException(new Error('Rest Menu Error: getCurrentItemEdit request failed'))
      })
      .then(() => {
        commit('setIsCurrentEditItemLoaded', true)
      })
  },
  openCloseEditItemModal({ commit }, isOpen) {
    commit('setEditItemOpen', isOpen)
    if (!isOpen) {
      commit('setCurrentEditItem', {})
    }
  },
  updateShowCart({ commit }, isOpen) {
    commit('setShowCart', isOpen)
  },
  updateCartIsLoading({ commit }, isLoading) {
    commit('setCartIsLoading', isLoading)
  },
  updateCurrentEditItemLoaded({ commit }, isLoaded) {
    commit('setIsCurrentEditItemLoaded', isLoaded)
  },
  addItemToCart({ dispatch, commit, state }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'ajaxAdd')
    params.append('itemId', payload.itemId)
    params.append('markup', state.restInfo.markup)
    params.append('qty', payload.qty)
    params.append('optns', payload.options)
    params.append('whofor', payload.whofor)
    params.append('comments', payload.specInstructions)
    if (payload.override) {
      params.append('override', payload.override)
    }

    return axios
      .post('/yourOrder.pl', params)
      .then((response) => {
        Vue.toasted.clear()
        if (response.data.success) {
          dispatch('showToastedSuccessMessage', 'Item added to cart!')
          if (payload.getCartData) {
            dispatch('getCustomerCartData')
          } else {
            var dollarsign = '$ '
            var subtotal = response.data.sucess.subtotal
            var total = response.data.sucess.total
            if (!parseFloat(subtotal)) {
              document.getElementById('nav_order_total').innerHTML = ''
            } else if (state.customerCartData.showStaffCartInfo) {
              if (parseFloat(total) >= 10) {
                dollarsign = '$'
              }
              document.getElementById('nav_order_total').innerHTML = dollarsign + total
            } else {
              if (parseFloat(subtotal) >= 10) {
                dollarsign = '$'
              }
              document.getElementById('nav_order_total').innerHTML = dollarsign + subtotal
            }
          }
          return true
        } else if (response.data.errors) {
          commit('setToastedMessage', response.data.errors)
          payload.ghost = false
          if (state.restInfo.showStaffTools) {
            dispatch('showClearCartOrOverride', payload)
          } else {
            dispatch('showClearCartOption', payload)
          }
          return false
        } else {
          commit('setToastedMessage', 'Failed to add item to cart.')
          dispatch('showToastedErrorMessage')
          return false
        }
      })
      .catch(function (error) {
        commit('setToastedMessage', 'Network request failed.')
        dispatch('showToastedErrorMessage')
        Sentry.captureException(new Error('Rest Menu Error: addItem request failed'))
        return false
      })
  },
  addSpecialItem({ dispatch, commit, state }, payload) {
    var params = new URLSearchParams()
    params.append('mode', 'addNew')
    params.append('ghost', true)
    params.append('cartid', state.restInfo.cartid)
    params.append('restId', payload.restId)
    params.append('gdesc', payload.specInstructions)
    params.append('gwhofor', payload.whofor)
    params.append('gqty', payload.qty)
    params.append('gprice', payload.price)
    params.append('gname', payload.name)
    if (payload.override) {
      params.append('override', payload.override)
    }

    return axios
      .post('/yourOrder.pl', params)
      .then((response) => {
        Vue.toasted.clear()
        if (response.data.success) {
          dispatch('showToastedSuccessMessage', 'Item added to cart!')
          var dollarsign = '$ '
          if (parseFloat(response.data.success.successMessage) >= 10) {
            dollarsign = '$'
          }
          var headerCartTotal = document.getElementById('nav_order_total')
          headerCartTotal.innerHTML = dollarsign + response.data.success.successMessage
          dispatch('getCustomerCartData')
        } else if (response.data.error) {
          commit('setToastedMessage', response.data.error.errorType)
          payload.ghost = true
          dispatch('showClearCartOrOverride', payload)
          return false
        } else {
          commit('setToastedMessage', 'Failed to add special item to cart.')
          dispatch('showToastedErrorMessage')
          return false
        }
      })
      .catch(function (error) {
        console.log(error)
        commit('setToastedMessage', 'Network request failed.')
        dispatch('showToastedErrorMessage')
        Sentry.captureException(new Error('Rest Menu Error: addNew ghost item request failed'))
        return false
      })
  },
  showToasted({ commit, state }, payload) {
    Vue.toasted.show(state.toastedMessage, {
      action: {
        text: 'DISMISS',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      },
    })
  },
  showToastedSuccessMessage({ commit, state }, payload) {
    Vue.toasted.success(payload, {
      duration: 2000,
      keepOnHover: true,
      className: 'toast-bubble-success',
    })
  },
  showToastedErrorMessage({ commit, state }, payload) {
    Vue.toasted.error(state.toastedMessage, {
      keepOnHover: true,
      duration: null,
      action: [
        {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          },
          class: 'toast-action',
        },
      ],
    })
  },
  showClearCartOption({ dispatch, state, getters }, payload) {
    dispatch('showToastedErrorMessage')
    const otherRestsInCart = getters.otherRestsInCart
    Vue.toasted.show(`Would you like to remove all items from cart to start a new order from ${state.restInfo.restInfoBanner.name}?`, {
      keepOnHover: true,
      duration: null,
      action: [
        {
          text: 'CANCEL',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          },
          class: 'toast-action',
        },
        {
          text: 'Clear Cart',
          onClick: async (e, toastObject) => {
            Vue.toasted.clear()
            dispatch('showToastedLoading')
            await dispatch('clearAllOtherRestOrders', state.restInfo.restid)
            await dispatch('addItemToCart', payload)
            dispatch('showToastedClearedCart', otherRestsInCart)
          },
          class: 'toast-action',
        },
      ],
    })
  },
  showClearCartOrOverride({ dispatch, state, getters }, payload) {
    dispatch('showToastedErrorMessage')
    const otherRestsInCart = getters.otherRestsInCart
    Vue.toasted.show('Select "CLEAR CART" to remove items in cart from all other restaurants OR "ADD ANYWAY" to override this setting.', {
      keepOnHover: true,
      duration: null,
      action: [
        {
          text: 'CANCEL',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          },
          class: 'toast-action',
        },
        {
          text: 'Clear Cart',
          onClick: async (e, toastObject) => {
            Vue.toasted.clear()
            dispatch('showToastedLoading')
            await dispatch('clearAllOtherRestOrders', state.restInfo.restid)
            if (payload.ghost) {
              await dispatch('addSpecialItem', payload)
            } else {
              await dispatch('addItemToCart', payload)
            }
            dispatch('showToastedClearedCart', otherRestsInCart)
          },
          class: 'toast-action',
        },
        {
          text: 'Add Anyway',
          onClick: (e, toastObject) => {
            Vue.toasted.clear()
            dispatch('showToastedLoading')
            payload.override = true
            if (payload.ghost) {
              dispatch('addSpecialItem', payload)
            } else {
              dispatch('addItemToCart', payload)
            }
          },
          class: 'toast-action',
        },
      ],
    })
  },
  showToastedLoading() {
    Vue.toasted.show('Loading..', { duration: null })
  },
  showToastedClearedCart({ getters }, otherRestsInCart) {
    let message = ''
    if (otherRestsInCart.length > 0) {
      message += otherRestsInCart.map((rest) => `${rest.restaurantName}`).join(', ')
    }
    message += otherRestsInCart.length > 1 ? 'have been cleared from your cart.' : ' has been cleared from your cart.'

    Vue.toasted.show(message, {
      duration: null,
      action: [
        {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0)
          },
          class: 'toast-action',
        },
      ],
    })
  },
}

export const mutations = {
  setMenu(state, menu) {
    Vue.set(state, 'tabs', menu)
  },
  setTab(state, newTab) {
    Vue.set(state, 'currentTab', newTab)
    Vue.set(state, 'initDefaultTab', newTab)
  },
  setRestInfo(state, restInfo) {
    Vue.set(state, 'restInfo', restInfo)
  },
  setDeliveryTime(state, deliveryTime) {
    Vue.set(state, 'deliveryTime', deliveryTime)
  },
  setCurrentItem(state, newItem) {
    Vue.set(state, 'currentItem', newItem)
  },
  setIsCurrentItemLoaded(state, newVal) {
    Vue.set(state, 'isCurrentItemLoaded', newVal)
  },
  setCurrentEditItem(state, editItemData) {
    Vue.set(state, 'currentEditItem', editItemData)
  },
  setEditItemOpen(state, isOpen) {
    if (isOpen) {
      ScrollLock.enable()
    } else {
      ScrollLock.disable()
    }
    Vue.set(state, 'editItemOpen', isOpen)
  },
  setShowCart(state, isOpen) {
    if (isOpen) {
      ScrollLock.enable()
    } else {
      ScrollLock.disable()
    }
    Vue.set(state, 'showCart', isOpen)
  },
  setCartIsLoading(state, isLoading) {
    Vue.set(state, 'cartIsLoading', isLoading)
  },
  setIsCurrentEditItemLoaded(state, newVal) {
    Vue.set(state, 'isCurrentEditItemLoaded', newVal)
  },
  setCustomerCartData(state, customerCartData) {
    Vue.set(state, 'customerCart', customerCartData)
    var dollarsign = '$ '
    var subtotal = customerCartData.subtotal
    var total = customerCartData.total
    if (!parseFloat(subtotal)) {
      document.getElementById('nav_order_total').innerHTML = ''
    } else if (customerCartData.showStaffCartInfo) {
      if (parseFloat(total) >= 10) {
        dollarsign = '$'
      }
      document.getElementById('nav_order_total').innerHTML = dollarsign + total
    } else {
      if (parseFloat(subtotal) >= 10) {
        dollarsign = '$'
      }
      document.getElementById('nav_order_total').innerHTML = dollarsign + subtotal
    }
  },
  setTotal(state, payload) {
    Vue.set(state.customerCart, 'total', payload)
    var dollarsign = '$ '
    if (parseFloat(payload) >= 10) {
      dollarsign = '$'
    }
    var headerCartTotal = document.getElementById('nav_order_total')
    headerCartTotal.innerText = dollarsign + payload
  },
  setTip(state, payload) {
    Vue.set(state.customerCart, 'gratuityAmount', payload)
  },
  setTipPercent(state, payload) {
    Vue.set(state.customerCart, 'gratuityPercent', payload)
  },
  setCoupon(state, payload) {
    if (payload.response.coupon) {
      Vue.set(state.customerCart, 'couponAdj', payload.response.coupon)
      Vue.set(state.customerCart, 'couponName', payload.couponName)
    } else {
      Vue.set(state.customerCart, 'couponAdj', ' 0.00')
      Vue.set(state.customerCart, 'couponName', '')
    }
  },
  setRestComment(state, payload) {
    state.customerCart.orders.forEach((rest) => {
      if (rest.id === payload.restId) {
        Vue.set(rest, 'specialInstructions', payload.comment)
      }
    })
  },
  setOverrideMin(state, payload) {
    Vue.set(state.customerCart, 'minMetOrOverridden', payload)
  },
  setMinimumStatus(state, payload) {
    Vue.set(state.customerCart, 'minimumStatus', payload)
  },
  setDifference(state, payload) {
    Vue.set(state.customerCart, 'difference', payload)
  },
  setCustIsPayingMinFee(state, payload) {
    Vue.set(state.customerCart, 'custIsPayingMinFee', payload)
  },
  setToastedMessage(state, newMessage) {
    Vue.set(state, 'toastedMessage', newMessage)
  },
}

export const getters = {
  currentItemObj: (state) => {
    return state.currentItem
  },
  isCurrentItemLoaded: (state) => {
    return state.isCurrentItemLoaded
  },
  currentEditItemObj: (state) => {
    return state.currentEditItem
  },
  isCurrentEditItemLoaded: (state) => {
    return state.isCurrentEditItemLoaded
  },
  allMenuHours: (state) => {
    var returnHours = []
    state.tabs.forEach((tab) => {
      var menuHours = {
        menuHoursName: tab.label,
        hours: tab.menuHours,
      }
      if (menuHours.hours.length > 0) {
        returnHours.push(menuHours)
      }
    })
    return returnHours
  },
  allowItemNotes: (state) => {
    if (state.tabs[0].allowItemNotes) {
      return true
    } else {
      return false
    }
  },
  otherRestsInCart: (state) => {
    let otherRests = []
    state.customerCart.orders.forEach((rest) => {
      if (rest.id != state.restInfo.restid) {
        otherRests.push(rest)
      }
    })
    return otherRests
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
